import { Link } from "react-router-dom";

const CoFoundTeaser = () => {
  return (
    <section className="container mx-auto px-4 sm:px-6 lg:px-8 mb-20">
      <div className="brutal-border brutal-shadow-lg bg-primary/10 rounded-md p-10 sm:p-16 text-center border-primary/40">
        <h2 className="text-3xl sm:text-4xl font-black text-foreground tracking-tight mb-4">
          Built your MVP? Let's get you funded.
        </h2>
        <p className="text-lg text-muted-foreground max-w-xl mx-auto mb-8">
          We're building a direct pipeline between founders who've shipped their MVP and seed funds actively backing AI-native startups. Coming soon.
        </p>
        <Link
          to="/co-found"
          className="inline-flex brutal-border brutal-shadow-lg bg-primary text-primary-foreground font-bold px-8 py-3 text-lg hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-none transition-all rounded-md uppercase tracking-[0.08em]"
        >
          Join the Waitlist →
        </Link>
        <p className="mt-4 text-sm font-medium text-muted-foreground">
          8 funds. Rolling review. India-first.
        </p>
      </div>
    </section>
  );
};

export default CoFoundTeaser;
